import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { createClient, ContentfulClientApi, Asset } from 'contentful';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  private client: ContentfulClientApi<undefined>; // `undefined` is the default type

  constructor() {
    this.client = createClient({
      space: environment.contentful.spaceId, // Contentful space ID
      accessToken: environment.contentful.accessToken, //Contentful access token
    });
  }

  /**
   * Fetches an asset by its ID from Contentful.
   * @param assetId The ID of the asset.
   * @returns A promise that resolves to the asset details.
   */
  fetchAssetById(assetId: string): Promise<Asset> {
    return this.client.getAsset(assetId);
  }
}
